<div
  class="card-container h-100"
  [ngClass]="{ fullscreen: isFullscreen }"
  [ngStyle]="style"
>
  @if (titleTemplate || title || endElement) {

  <div class="card-header" [ngStyle]="headerStyle">
    @if (titleTemplate) {
    <ng-container
      class="h-100"
      *ngTemplateOutlet="titleTemplate"
    ></ng-container>
    } @else {
    <div class="card-header-text">{{ title }}</div>

    }
    <div class="d-flex align-items-center endelements-wrapper">
      <!-- Helper Text -->
      @if(helperText){
      <ng-container *ngTemplateOutlet="helperText"></ng-container>
      }

      <!-- End Element (Optional content) -->
      <ng-container *ngIf="endElement">
        <ng-container
          *ngTemplateOutlet="
            endElement;
            context: {
              $implicit: endElementData
            }
          "
        ></ng-container>
      </ng-container>
      @if(downloadChart && id){
      <ng-container>
        <download-chart [id]="id" [title]="title"></download-chart>
      </ng-container>
      }

      <!-- Download Button -->
      @if(downloadIcon?.enable){
      <app-icon
        [icon]="'DOWNLOAD'"
        [tooltip]="'Download'"
        (click)="downloadIcon?.onClick()"
      ></app-icon>
      }

      <!-- Customize Column Button -->
      <button
        *ngIf="customizeColumn?.enable"
        class="btn btn-link p-0"
        (click)="customizeColumn?.onClick()"
      >
        <app-icon icon="SETTINGS" [iconSize]="'1rem'"></app-icon>
      </button>
      @if (expandable) { @if(!avoidExpand){

      <app-icon
        (click)="toggleFullscreen()"
        [iconSize]="'1.3rem'"
        [tooltip]="isFullscreen ? 'Close' : 'Expand'"
        [icon]="isFullscreen ? 'CLOSE' : 'OPEN_IN_FULL'"
      >
      </app-icon>
      } }
    </div>
  </div>
  } @if(!avoidHr) {
  <hr class="hr" />
  }

  <!-- Card Body -->
  <div
    class="card-body"
    [style]="isCursorPagination ? 'height:81%' : 'height: 87%'"
    [ngStyle]="cardBodyStyle"
    [ngClass]="{ 'fullscreen-body': isFullscreen, 'overflow-y-auto': fromTab }"
  >
    @if(widgetLoading){
    <div class="skeleton-grid" style="height: 100%">
      @for (col of [0,1,2]; track $index) {
      <div class="skeleton-col">
        <p-skeleton
          width= '70%'
          height="1rem"
          class="centered-line mb-2"
        ></p-skeleton>
        <p-skeleton
          width="30%"
          height="1rem"
          class="centered-line"
        ></p-skeleton>
      </div>

      }
    </div>
    }
    @else if(chartLoading){
      <div class="d-flex align-items-end justify-content-evenly h-100 pb-2">
        @for(height of [80,60,40,90,30]; track $index) {
         <p-skeleton width="2rem" height="100%" [style.height.%]="height" class="mr-2" />
        }
      </div>
    } 
    @else if(donutLoading){
    <div class="donut-loading" role="status" aria-label="Loading chart">
      <div class="ring">
        <p-skeleton width="100%" height="100%"></p-skeleton>
        <div class="hole"></div>
      </div>
    </div>

    } @else if(loading){
    <div
      class="d-flex justify-content-center align-items-center"
      style="height: 100%"
    >
      <app-loader></app-loader>
    </div>
    } @else {
    <ng-content></ng-content>
    }
  </div>
  <div
    *ngIf="isCursorPagination"
    class="me-3"
    style="display: flex; justify-content: flex-end; gap: 1rem"
  >
    <app-icon-button
      icon="KEYBOARD_ARROW_LEFT"
      (click)="cursorPagination?.onPrevPageClick()"
      [title]="'Prev'"
      [disabled]="cursorPagination && cursorPagination.cursorList.length === 0"
      class="cursor-pagination-icon"
    ></app-icon-button>
    <app-icon-button
      icon="KEYBOARD_ARROW_RIGHT"
      (click)="cursorPagination?.onNextPageClick()"
      [title]="'Next'"
      [disabled]="!cursorPagination?.hasNext"
      class="cursor-pagination-icon"
    ></app-icon-button>
  </div>
</div>
